import React, { Component } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createUser, logOutUser, setMonthYear, loadStatus } from "../actions/postAction";

import axios from "axios";
import { BASE_URL } from "../constant";
import Swal from "sweetalert2";
import { NetworkError } from "./NetworkError";
import { Loading } from "./Loading";

import moment from "moment";
import "moment-timezone";
import Select from "react-select";
const selectStyles = {
  menu: base => ({
    ...base,
    zIndex: 100
  })
};

class UserHome extends Component {
  constructor(props) {
    super(props);
    this.month_name = this.month_name.bind(this);
    this.state = {
      tajneed: false,
      atfal: false,
      etemad: false,
      tabligh: false,
      audit: false,
      ishaat: false,
      maal: false,
      taleem: false,
      waqar_amal: false,
      general: false,
      health: false,
      new_convert: false,
      social: false,
      student: false,
      tahrik: false,
      tarbiyya: false,
      trade: false,
      networkError: false,
      isLoading: false,
      month: {
        label: this.month_name(this.props.monthYear.month),
        value: this.props.monthYear.month
      },
      year: {
        label: this.props.monthYear.year,
        value: this.props.monthYear.year
      }
    };
  }

  month_name(dt) {
    var mlist = [
      "",
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];
    return mlist[dt];
  }
  options = [
    { label: 2024, value: 2024 },
    { label: 2023, value: 2023 },
    { label: 2022, value: 2022 },
    { label: 2021, value: 2021 },
    { label: 2020, value: 2020 },
    { label: 2019, value: 2019 },
    { label: 2018, value: 2018 },
    { label: 2017, value: 2017 },
    { label: 2016, value: 2016 },
    { label: 2015, value: 2015 },
    { label: 2014, value: 2014 },
    { label: 2013, value: 2013 },
    { label: 2012, value: 2012 },
    { label: 2011, value: 2011 },
    { label: 2010, value: 2010 },
    { label: 2009, value: 2009 },
    { label: 2008, value: 2008 },
    { label: 2007, value: 2007 },
    { label: 2006, value: 2006 },
    { label: 2005, value: 2005 },
    { label: 2004, value: 2004 },
    { label: 2003, value: 2003 },
    { label: 2002, value: 2002 },
    { label: 2001, value: 2001 },
    { label: 2000, value: 2000 },
    { label: 1775, value: 1775 },
  ];

  months = [
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 }
  ];
  componentDidMount() {
    const { month, year } = this.props.monthYear;
    document.title = "Dashboard - MKAN REPORT";
    //this.checkStatus(month, year);
  }
  handleChangeYear(value) {
    const { month } = this.props.monthYear;
    this.setState({ year: value });
    const monthYear = {
      month: month,
      year: value.value
    };
    this.props.setMonthYear(monthYear);
    this.props.loadStatus(month, value.value);
  }

  handleChangeMonth(value) {
    // this.setState({ month: value });

    // this.checkStatus(value.value, this.state.value.value);
    const { year } = this.props.monthYear;
    this.setState({ month: value });
    const monthYear = {
      month: value.value,
      year: year
    };
    this.props.setMonthYear(monthYear);
    this.props.loadStatus(value.value, year);
  }
  render() {
    const { month, year, isLoading } = this.state;
    const {data, failed, isFetching} = this.props.status;
    return (
      <section className="content">
        {this.state.networkError || failed  ? (
          <NetworkError />
        ) : (
          <div>
            <center>
              <div className="col-md-12">
                <h4 className="title">Select Year and Month below </h4>
                <div className="row">
                  <div className="col-lg-5 col-md-6 col-sm-3 m-3 zin">
                    <div className="">
                      <Select
                        styles={selectStyles}
                        options={this.options}
                        value={year}
                        onChange={value => this.handleChangeYear(value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-5 col-md-6 col-sm-3 m-3 zin2">
                    <div className="dropdown bootstrap-select dropup">
                      <Select
                        styles={selectStyles}
                        options={this.months}
                        value={month}
                        onChange={value => this.handleChangeMonth(value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </center>
            {/* <center>
              <h2>Your report status for {moment().format("MMMM")} </h2>
            </center> */}
            {isFetching ? (
                <div className="text-center container">
                  <center>
                    <Loading />
                  </center>
                </div>
            ) : (
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="card card-stats">
                  <div className="card-header card-header-warning card-header-icon">
                    <div className="card-icon">
                      <i className="material-icons">check_circle</i>
                    </div>
                    <p className="card-category">Tabligh</p>
                    <h3 className="card-title">
                      {data.tabligh ? "Submitted" : "Not submitted"}
                    </h3>
                  </div>
                  <div className="card-footer">
                    <div className="stats">
                      <i className="material-icons text-success">
                        info_outline
                      </i>
                      <a href="#pablo">Outreach</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="card card-stats">
                  <div className="card-header card-header-success card-header-icon">
                    <div className="card-icon">
                      <i className="material-icons">child_care</i>
                    </div>
                    <p className="card-category">Atfal</p>
                    <h3 className="card-title">
                      {data.atfal ? "Submitted" : "Not submitted"}
                    </h3>
                  </div>
                  <div className="card-footer">
                    <div className="stats">
                      <i className="material-icons">child_care</i> Children
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="card card-stats">
                  <div className="card-header card-header-rose card-header-icon">
                    <div className="card-icon">
                      <i className="material-icons">people_outlin...</i>
                    </div>
                    <p className="card-category">Tajneed</p>
                    <h3 className="card-title">
                      {data.tajnid ? "Submitted" : "Not submitted"}
                    </h3>
                  </div>
                  <div className="card-footer">
                    <div className="stats">
                      <i className="material-icons">local_offer</i> Census
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="card card-stats">
                  <div className="card-header card-header-info card-header-icon">
                    <div className="card-icon">
                      <i className="material-icons">home</i>
                    </div>
                    <p className="card-category">A'itmad</p>
                    <h3 className="card-title">
                      {data.secretariat ? "Submitted" : "Not submitted"}
                    </h3>
                  </div>
                  <div className="card-footer">
                    <div className="stats">
                      <i className="material-icons">update</i> Secretariat
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="card card-stats">
                  <div className="card-header card-header-success card-header-icon">
                    <div className="card-icon">
                      <i className="material-icons">money</i>
                    </div>
                    <p className="card-category">Muhasib</p>
                    <h3 className="card-title">
                      {data.audit ? "Submitted" : "Not submitted"}
                    </h3>
                  </div>
                  <div className="card-footer">
                    <div className="stats">
                      <i className="material-icons">update</i> Audit
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="card card-stats">
                  <div className="card-header card-header-rose card-header-icon">
                    <div className="card-icon">
                      <i className="material-icons">book</i>
                    </div>
                    <p className="card-category">Ishaat</p>
                    <h3 className="card-title">
                      {data.ishaat ? "Submitted" : "Not submitted"}
                    </h3>
                  </div>
                  <div className="card-footer">
                    <div className="stats">
                      <i className="material-icons">book</i> Publications
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="card card-stats">
                  <div className="card-header card-header-info card-header-icon">
                    <div className="card-icon">
                      <i className="material-icons">attach_money</i>
                    </div>
                    <p className="card-category">Maal</p>
                    <h3 className="card-title">
                      {data.maal ? "Submitted" : "Not submitted"}
                    </h3>
                  </div>
                  <div className="card-footer">
                    <div className="stats">
                      <i className="material-icons">attach_money</i> Finance
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="card card-stats">
                  <div className="card-header card-header-warning card-header-icon">
                    <div className="card-icon">
                      <i className="material-icons">border_color</i>
                    </div>
                    <p className="card-category">Taleem</p>
                    <h3 className="card-title">
                      {data.taleem ? "Submitted" : "Not submitted"}
                    </h3>
                  </div>
                  <div className="card-footer">
                    <div className="stats">
                      <i className="material-icons text-success">
                        border_color
                      </i>
                      <a href="#pablo">Education</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="card card-stats">
                  <div className="card-header card-header-info card-header-icon">
                    <div className="card-icon">
                      <i className="material-icons">equalizer</i>
                    </div>
                    <p className="card-category">Waqar E Amal</p>
                    <h3 className="card-title">
                      {data.waqar_amal ? "Submitted" : "Not submitted"}
                    </h3>
                  </div>
                  <div className="card-footer">
                    <div className="stats">
                      <i className="material-icons">equalizer</i> Dignity of
                      Labour
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="card card-stats">
                  <div className="card-header card-header-success card-header-icon">
                    <div className="card-icon">
                      <i className="material-icons">layers</i>
                    </div>
                    <p className="card-category">Umoomi</p>
                    <h3 className="card-title">
                      {data.general ? "Submitted" : "Not submitted"}
                    </h3>
                  </div>
                  <div className="card-footer">
                    <div className="stats">
                      <i className="material-icons">layers</i> Special Duties
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="card card-stats">
                  <div className="card-header  card-header-icon card-header-text">
                    <div className="card-icon">
                      <i className="material-icons">local_hospital</i>
                    </div>
                    <p className="card-category">SEHRAT E JISMANI</p>
                    <h3 className="card-title">
                      {data.health ? "Submitted" : "Not submitted"}
                    </h3>
                  </div>
                  <div className="card-footer">
                    <div className="stats">
                      <i className="material-icons">local_hospital</i> Fitness
                      and Wellness
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="card card-stats">
                  <div className="card-header card-header-info card-header-icon">
                    <div className="card-icon">
                      <i className="material-icons">fiber_new</i>
                    </div>
                    <p className="card-category">Nou-Mubayin</p>
                    <h3 className="card-title">
                      {data.new_convert ? "Submitted" : "Not submitted"}
                    </h3>
                  </div>
                  <div className="card-footer">
                    <div className="stats">
                      <i className="material-icons">fiber_new</i> New Convert
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="card card-stats">
                  <div className="card-header card-header-warning card-header-icon">
                    <div className="card-icon">
                      <i className="material-icons">mood</i>
                    </div>
                    <p className="card-category">Khidmat E Khalq</p>
                    <h3 className="card-title">
                      {data.social ? "Submitted" : "Not submitted"}
                    </h3>
                  </div>
                  <div className="card-footer">
                    <div className="stats">
                      <i className="material-icons text-success">mood</i>
                      <a href="#pablo">Welfarism</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="card card-stats">
                  <div className="card-header card-header-rose card-header-icon">
                    <div className="card-icon">
                      <i className="material-icons">school</i>
                    </div>
                    <p className="card-category">Umoor-e-Tulaba</p>
                    <h3 className="card-title">
                      {data.student ? "Submitted" : "Not submitted"}
                    </h3>
                  </div>
                  <div className="card-footer">
                    <div className="stats">
                      <i className="material-icons">school</i> Students Affair
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="card card-stats">
                  <div className="card-header card-header-primary card-header-icon">
                    <div className="card-icon">
                      <i className="material-icons">format_size</i>
                    </div>
                    <p className="card-category">Tahrik E Jadid</p>
                    <h3 className="card-title">
                      {data.tahrik ? "Submitted" : "Not submitted"}
                    </h3>
                  </div>
                  <div className="card-footer">
                    <div className="stats">
                      <i className="material-icons">format_size</i> New Scheme
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="card card-stats">
                  <div className="card-header card-header-warning card-header-icon">
                    <div className="card-icon">
                      <i className="material-icons">warning</i>
                    </div>
                    <p className="card-category">Tarbiyyah</p>
                    <h3 className="card-title">
                      {data.tarbiyya ? "Submitted" : "Not submitted"}
                    </h3>
                  </div>
                  <div className="card-footer">
                    <div className="stats">
                      <i className="material-icons text-success">warning</i>
                      <a href="#pablo">Ethics</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6">
                <div className="card card-stats">
                  <div className="card-header card-header-primary card-header-icon">
                    <div className="card-icon">
                      <i className="material-icons">shop</i>
                    </div>
                    <p className="card-category">Sanat O Tijarat</p>
                    <h3 className="card-title">
                      {data.trade ? "Submitted" : "Not submitted"}
                    </h3>
                  </div>
                  <div className="card-footer">
                    <div className="stats">
                      <i className="material-icons text-success">shop</i>
                      <a href="#pablo">Trade and Commerce</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
                )}
          </div>
        )}
      </section>
    );
  }
}

UserHome.propTypes = {
  createUser: PropTypes.func.isRequired,
  logOutUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired
};
const mapStateToProps = state => ({
  user: state.person.user,
  isLoggedIn: state.person.isLoggedIn,
  monthYear: state.currentMonth.monthYear,
  status: state.status,
});

export default connect(mapStateToProps, {
  createUser,
  logOutUser,
  setMonthYear,
  loadStatus,
})(UserHome);
